var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"fixed top-0 left-0 right-0 bottom-0 z-50 bg-black bg-opacity-70 flex justify-center items-center p-4"},[_c('div',{staticClass:"bg-white text-center w-full max-w-[400px] p-4 rounded-lg"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }